import React from 'react';
import { motion } from 'framer-motion';
interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
}
export function ProgressBar({
  currentStep,
  totalSteps
}: ProgressBarProps) {
  const progress = currentStep / totalSteps * 100;
  return <div className="w-full max-w-2xl mx-auto mb-12" data-id="element-37">
      <div className="flex justify-between items-end mb-3 px-1" data-id="element-38">
        <span className="text-sm font-medium text-burgundy-600/70 uppercase tracking-wider" data-id="element-39">
          Progreso
        </span>
        <span className="text-sm font-medium text-burgundy-800" data-id="element-40">
          {Math.round(progress)}%
        </span>
      </div>
      <div className="h-2 w-full bg-cream-300 rounded-full overflow-hidden" data-id="element-41">
        <motion.div className="h-full bg-gradient-to-r from-burgundy-500 to-burgundy-600 rounded-full" initial={{
        width: 0
      }} animate={{
        width: `${progress}%`
      }} transition={{
        duration: 0.5,
        ease: 'easeInOut'
      }} data-id="element-42" />
      </div>
    </div>;
}